import styles from './style.module.css';

export default function Err({ children }) {
	if (!children) return null;
	return <div className={styles.err}>
		{children}
	</div>	
}